<template lang="pug">

  .userList

    //- Campo de busca de usuários
    .userSearchContainer
      input(
        ref="userSearchInputRef"
        type="text"
        v-model="searchUserText"
        maxlength="56"
        placeholder="Digite para buscar usuários..."
        class="userSearchField"
        @click="focusUserSearchInput"
        @input="onSearchInput"
        :disabled="disabled"
      )

    //- :title="user.userEmail || 'Sem e-mail'"
    div(v-for="(user, userIndex) in filteredUsers" @click="onSelectedUser(user)" :key="user.uid")

      //- v-tooltip(top color="rgba(0, 0, 0, 0.9)")
      v-tooltip(top :color="user.userTime !== false ? 'rgba(0, 0, 139, 0.95)' : 'rgba(0, 0, 0, 0.9)' /* 'rgba(139, 0, 0, 0.95)' */")

        template(v-slot:activator="{ on, attrs }")

          .userItem(v-bind="attrs" v-on="on" :class="{ 'userItem--last': userIndex === users.length - 1, 'userItem--checked': user.checked }")
            .userImage(:style="{ backgroundImage: `url('${user.userImage}')` }")
            .userName {{ user.userName }}
            .userEmail {{ user.userEmail || 'Sem e-mail' }}
            .userTime(v-if="user.userTime !== false") PONTO

        span
          b &nbsp;{{ user.userName }}
          br
          b(:style="{ 'color': user.userTime === false ? 'orange' : '#FFFF00' }") &nbsp;{{ user.userTime === 'START' ? 'Registrou início de plantão' : (user.userTime === 'START_END' ? 'Registrou início e fim de plantão' : 'Não registrou ponto') }}

</template>

<script>

  import SosCheckbox from '@/components/SosCheckbox'

  export default {
    name: 'UsersListComponent',

    components: {
      'sos-checkbox': SosCheckbox,
    },

    props: {
      users: {
        type: Array,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        searchUserText: '',
        userSearchInputRef: null,
      }
    },

    computed: {
      // Usuários filtrados baseado no texto de busca
      filteredUsers() {
        if (!this.searchUserText || this.searchUserText.trim() === '') {
          return this.users;
        }

        const searchTerm = this.searchUserText.toLowerCase().trim();
        return this.users.filter(user =>
          user.userName.toLowerCase().includes(searchTerm) ||
          (user.userEmail && user.userEmail.toLowerCase().includes(searchTerm)) ||
          user.uid.toString().includes(searchTerm)
        );
      },
    },

    watch: {
      // Limpar campo de busca quando a lista de usuários mudar
      users: {
        handler() {
          this.searchUserText = '';
        },
      },
    },

    methods: {
      onSelectedUser (user) {
        this.$emit('click', user)
      },

      // Método para focar no input de busca
      focusUserSearchInput() {
        const inputElement = this.$refs.userSearchInputRef;
        if (inputElement && inputElement.focus) {
          inputElement.focus();
        }
      },

      // Método para limpar o campo de busca
      clearSearch() {
        this.searchUserText = '';
      },

      // Método para lidar com mudanças no campo de busca
      onSearchInput() {
        this.$emit('search', this.searchUserText);
      },
    },
  }

</script>

<style scoped lang="scss">

  .userList {
    max-height: 181px;
    overflow: auto;

    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.15);
  }

  // Campo de busca de usuários
  .userSearchContainer {
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: white;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    padding: 8px;
  }

  .userSearchField {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    font-size: 14px;
    line-height: 1.4;
    outline: none;
    transition: border-color 0.2s ease;

    &:focus {
      border-color: #e54245;
      box-shadow: 0 0 0 2px rgba(229, 66, 69, 0.1);
    }

    &:disabled {
      background-color: #f5f5f5;
      cursor: not-allowed;
      opacity: 0.6;
    }

    &::placeholder {
      color: #999;
    }
  }

  .userItem {
    cursor: pointer;

    position: relative;

    width: 100%;
    min-height: 40px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);

    &::before,
    &::after {
      transition-property: background-color;
      transition-duration: 150ms;

      content: "";

      position: absolute;
      width: 2px;
      background-color: transparent;
    }

    &::before {
      top: 19px;
      right: 19px;

      height: 6px;
      transform: rotate(-45deg);
    }

    &::after {
      top: 14px;
      right: 13px;

      height: 12px;
      transform: rotate(40deg);
    }

    &--last {
      border-bottom: 0;
    }

    &--checked {
      &:before,
      &:after {
        background-color: #e54245;
      }
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }
  }

  .userImage {
    position: absolute;
    top: 3px;
    left: 6px;

    display: inline-block;
    vertical-align: middle;
    width: 33px;
    height: 33px;
    border-radius: 50%;
    background-position: center;
    background-size: cover;
    background-color: #333333;
  }

  .userName,
  .userEmail {
    user-select: none;

    position: absolute;
    left: 0;

    display: inline-block;
    vertical-align: middle;
    width: 100%;
    padding-left: 47px;
    padding-right: 6px;

    line-height: 1.5;

    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .userName {
    top: 2px;

    color: #555555;
    font-size: 14px;
    font-weight: 500;
  }

  .userEmail {
    top: 19px;

    color: #808080;
    font-size: 12.5px;
  }

  .userItem--checked {
    .userName {
      padding-right: 30px;

      color: forestgreen;
    }

    .userEmail {
      padding-right: 30px;
    }
  }

  .userTime {
    user-select: none;

    position: absolute;
    left: 4px;
    top: 29px;

    display: inline-block;
    width: 37px;
    border-radius: 7px;
    background-color: rgba(0, 0, 0, 0.7);

    color: yellow;
    font-size: 9px;
    font-weight: 800;
    line-height: 10px;
    text-align: center;
  }

</style>
